import { useMutation, useQuery } from "@tanstack/react-query";
import { axiosInstance } from "../axios";

export const followMember = async (id) => {
  const response = await axiosInstance.post(
    `/umbraco/api/members/${id}/follow`
  );
  return response.data;
};

export const unfollowMember = async (id) => {
  const response = await axiosInstance.delete(
    `/umbraco/api/members/${id}/follow`
  );
  return response.data;
};

export const useCmsFollowMember = () => {
  return useMutation({
    mutationFn: async ({ id }) => {
      await followMember(id);
    },
    onSuccess: (_, { successHandler }) => {
      if (successHandler) {
        successHandler();
      }
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};

export const useCmsUnfollowMember = () => {
  return useMutation({
    mutationFn: async ({ id }) => {
      await unfollowMember(id);
    },
    onSuccess: (_, { successHandler }) => {
      if (successHandler) {
        successHandler();
      }
    },
    onError: (_, { errorHandler }) => {
      if (errorHandler) {
        errorHandler();
      }
    },
  });
};

export const fetchFollowings = async () => {
  const response = await axiosInstance.get(`/umbraco/api/members/followings`);
  return response.data;
};

export const useFollowings = () => {
  return useQuery({
    queryKey: ["followings"],
    queryFn: fetchFollowings,
  });
};
